export default __webpack_public_path__ + "static/media/bnb-rosn-closed-logo.5c9970cd.svg";